































































































import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import NavbarMenu from './Navbar/NavbarMenu.vue';
import { HubCard, HubIcon, HubHeading } from './HubComponents';

export default Vue.extend({
  name: 'AppTopbar',

  components: {
    HubCard,
    HubIcon,
    HubHeading,
    NavbarMenu,
  },

  props: {
    notification: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      menu: false,
    };
  },
  computed: {
    ...mapState(['user']),
    mobile(): boolean {
      return this.$vuetify.breakpoint.mobile;
    },
    isGalleriesOrGalleryRoute(): boolean {
      return this.$route.path.includes('galleries') || this.$route.path.includes('gallery') || this.$route.path.includes('video') || this.$route.path.includes('events') || this.$route.path.includes('transcription') || this.$route.path.includes('logs');
    },
  },
  watch: {
    $route(): void {
      this.menu = false;
    },
  },
  methods: {
    ...mapActions({ logout: 'user/logout' }),
  },
});
